<template>
  <surround-box title="荣昌区生猪年养殖规模">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
      <div class="unit">单位：{{ unit }}</div>
    </div>
  </surround-box>
</template>
<script>
import surroundBox from "@/components/mapComp/surroundBox2.vue";
import * as echarts from "echarts";

export default {
  components: {
    surroundBox,
  },
  data() {
    return {
      data: [],
      unit: "",
    };
  },
  methods: {
    //   初始化
    initChart() {
      let chart = echarts.init(this.$refs.chart);
      let options = {
        grid: {
          containLabel: true,
          top: 48,
          left: 16,
          right: 32,
          bottom: 16,
        },
        xAxis: {
          data: this.data.map((item) => item.years),
          axisLabel: {
            color: "#fff",
          },
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: ["#fff"],
              type: "dashed",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#fff"],
              type: "dashed",
            },
          },
        },
        yAxis: {
          axisLabel: {
            color: "#fff",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#fff"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            type: "line",
            data: this.data.map((item) => item.num || 0),
            lineStyle: {
              color: "#1DD8BE",
            },
            label: {
              show: true,
              color: '#FFF'
            },

            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(186, 255, 125, .8)",
                },
                {
                  offset: 0.8,
                  color: "rgba(29, 216, 190, 0)",
                },
              ]),
            },
          },
        ],
      };
      chart.setOption(options);
    },
    getStatics() {
      return this.$post('statistics/onLineNum', {
      }).then((res) => {
        console.log(res);
        this.data = res;
        this.unit = '只';
      });
    },
  },
  mounted() {
    this.getStatics().then(() => {
      this.initChart();
    });
  },
};
</script>
<style lang='less' scoped>
.chart-box {
  width: 100%;
  height: 230px;
  position: relative;
  .chart {
    width: 100%;
    height: 200px;
  }
  .unit {
    position: absolute;
    left: 16px;
    top: 12px;
    color: #fff;
    font-weight: bold;
  }
}
</style>
